export default {

    title: 'Mijn Aveco de Bondt',
    homeRoute: 'users'
}